﻿<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';
    import {
        compareByIdentity,
        compareByIsInSet,
        Scope
    } from '@/shared/components/scopeselector/scopeSelectionHelper.ts';
    import ScopeSelectorBase from '@/shared/components/scopeselector/ScopeSelectorBase.vue';
    import { chainComparers } from '@/shared/helpers/utils';

    type Props = {
        scopes: Scope[];
        disabledScopes?: string[];
    };

    const props = withDefaults(defineProps<Props>(), {
        disabledScopes: () => []
    });

    const selectedScopes = defineModel<string[]>('selectedScopes', { required: true });

    const selectedScopesOnMountedSet = ref<Set<string>>(new Set<string>());

    function compareByIsSelectedOnMounted(a: Scope, b: Scope): number {
        return compareByIsInSet(a, b, selectedScopesOnMountedSet.value);
    }

    const sortedScopes = computed(() => [...props.scopes].sort(chainComparers(compareByIsSelectedOnMounted, compareByIdentity)));

    onMounted(() => {
        selectedScopesOnMountedSet.value = new Set<string>(selectedScopes.value);
    });

</script>

<template>
    <scope-selector-base
        v-model:selected-scopes="selectedScopes"
        :scopes="sortedScopes"
        :disabled-scopes="props.disabledScopes" />
</template>
